import React from "react";
import styled from "styled-components";
import { Spacing, form, useTheme } from "@glossy";
import Counter from "@ui-kit/chip/counter";
import Tribox from "@ui-kit/form/tribox";
import Icon from "@ui-kit/icon";
import { ClassificationFilter, Status } from "@radarly/models/filters";
import {
  getCheckValue,
  getOnChangeStatus,
  getToggleClickStatus,
} from "./utils";

interface IProps {
  filter: ClassificationFilter;
  subfilters: { included: number; excluded: number };
  onClickFilter: () => void;
  onChange: (status: string) => void;
  hasChevron?: boolean;
  selected?: boolean;
}

const Root = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.selected && "#f1f2f6"};
  padding: ${Spacing.ExtraSmall} ${Spacing.ExtraSmall} ${Spacing.ExtraSmall} 0;
`;

const Infos = styled.div<{ onClick: () => void }>`
  justify-content: space-between;
  width: 100%;
  display: flex;
  cursor: ${({ onClick }) => !!onClick && "pointer"};
`;

const Label = styled.span<{ checked: boolean }>`
  margin-left: 2px;
  font-size: 14px;
  color: ${(props) =>
    form(
      props,
      props.checked === true
        ? "include"
        : props.checked === false
        ? "exclude"
        : "primary"
    )};
  text-decoration: ${(props) => props.checked === false && "line-through"};
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Summary = styled.div`
  display: flex;
  align-items: center;
  color: ${form};
  column-gap: ${Spacing.ExtraSmall};
`;

const Chevron = styled.div`
  color: ${form};
`;

const FilterbarPanelsClassificationFilter = ({
  filter,
  onChange,
  subfilters,
  onClickFilter,
  hasChevron = true,
  selected = false,
}: IProps) => {
  const isNeutral = subfilters.included > 0 || subfilters.excluded > 0;
  const theme = useTheme();

  return (
    <Root selected={selected}>
      <Tribox
        checked={getCheckValue(filter.status, isNeutral)}
        onClick={() => onChange(getToggleClickStatus(filter.status))}
        onClickCheck={(checked) =>
          onChange(getOnChangeStatus(filter, checked, isNeutral))
        }
        allowExclusion
        isNeutral={isNeutral}
      />
      <Infos onClick={onClickFilter}>
        <Label checked={getCheckValue(filter.status, isNeutral)}>
          {filter.label}
        </Label>
        <Summary>
          <Counter
            count={subfilters?.included}
            $color={form(theme, Status.Include)}
          />
          <Counter
            count={subfilters?.excluded}
            $color={form(theme, Status.Exclude)}
          />
          {hasChevron && (
            <Chevron>
              <Icon glyph="chevron-right" size={8} />
            </Chevron>
          )}
        </Summary>
      </Infos>
    </Root>
  );
};

export default FilterbarPanelsClassificationFilter;
